import { render, staticRenderFns } from "./TeamMemberUpdate.vue?vue&type=template&id=507e52c8&"
import script from "./TeamMemberUpdate.vue?vue&type=script&lang=js&"
export * from "./TeamMemberUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports